<template>
    <h4 class="mt-3 mb-3 text-center">Totals by Month</h4>

    <div class="row mb-3">
        <div class="col">
            <div class="form-floating">
                <select class="form-select" name="year" v-on:change="getData" v-model="year">
                    <option v-for="n in lastYear-(firstYear-1)" :value="n + (firstYear - 1)">
                        {{ n + (firstYear - 1) }}
                    </option>
                </select>
                <label for="inputYear">Year</label>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 col-lg-6">
            <table class="table table-striped mb-3" v-if="events.length">
                <thead>
                    <tr>
                        <th scope="col">Month</th>
                        <th scope="col" class="text-center">Rainfall (mm)</th>
                        <th scope="col" class="text-center"><i class="bi-cloud-fog p-1"></i></th>
                        <th scope="col" class="text-center"><i class="bi-cloud-hail p-1"></i></th>
                        <th scope="col" class="text-center"><i class="bi-cloud-snow p-1"></i></th>
                        <th scope="col" class="text-center"><i class="bi-cloud-lightning p-1"></i></th>
                        <th scope="col" class="text-center"><i class="bi-sun p-1"></i></th>
                        <th scope="col" class="text-center"><i class="bi-cloud p-1"></i></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="event in events">
                        <td>{{ event.monthname }}</td>
                        <td class="text-center">{{ event.rainfall }}</td>
                        <td class="text-center">{{ event.fog }}</td>
                        <td class="text-center">{{ event.hail }}</td>
                        <td class="text-center">{{ event.snow }}</td>
                        <td class="text-center">{{ event.thunder }}</td>
                        <td class="text-center">{{ event.sun }}</td>
                        <td class="text-center">{{ event.cloud }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th>Total</th>
                        <th class="text-center">{{ totalRainfall }}</th>
                        <th class="text-center">{{ totalFog }}</th>
                        <th class="text-center">{{ totalHail }}</th>
                        <th class="text-center">{{ totalSnow }}</th>
                        <th class="text-center">{{ totalThunder }}</th>
                        <th class="text-center">{{ totalSun }}</th>
                        <th class="text-center">{{ totalCloud }}</th>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="col-md-12 col-lg-6">
            <highcharts :options="chartOptions"></highcharts>
        </div>
    </div>

    <div class="mb-3" v-if="!events.length && showMessage">
        <p>There are no events defined for this period</p>
    </div>
</template>

<script>
export default {
    props: [
        'username',
        'firstYear',
        'lastYear',
    ],
    data() {
        return {
            year: this.lastYear, // The last year of Events the user entered.
            events: [],
            showMessage: false,
            chartOptions: {
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Total Monthly Rainfall (mm)'
                },
                colors: ['#00303F', '#39603d', '#3c403d', '#a3bcb6'],
                plotOptions: {
                    column: {
                        pointPadding: 0,
                    }
                },
                xAxis: {
                    categories: [
                        'Jan',
                        'Feb',
                        'Mar',
                        'Apr',
                        'May',
                        'Jun',
                        'Jul',
                        'Aug',
                        'Sep',
                        'Oct',
                        'Nov',
                        'Dec'
                    ]
                },
                yAxis: {
                    title: false
                },
                series: [{
                    showInLegend: true,
                    data: [],
                    name: "Total Rainfall (mm)"
                }]
            }
        };
    },
    computed: {
        totalRainfall: function() {
            return this.events.reduce(function(total, item) {
                return total + Number(item.rainfall);
            }, 0).toFixed(1);
        },
        totalFog: function(){
            return this.events.reduce(function(total, item) {
                return total + Number(item.fog);
            }, 0).toFixed(0);
        },
        totalHail: function(){
            return this.events.reduce(function(total, item) {
                return total + Number(item.hail);
            }, 0).toFixed(0);
        },
        totalSnow: function(){
            return this.events.reduce(function(total, item) {
                return total + Number(item.snow);
            }, 0).toFixed(0);
        },
        totalThunder: function(){
            return this.events.reduce(function(total, item) {
                return total + Number(item.thunder);
            }, 0).toFixed(0);
        },
        totalSun: function(){
            return this.events.reduce(function(total, item) {
                return total + Number(item.sun);
            }, 0).toFixed(0);
        },
        totalCloud: function(){
            return this.events.reduce(function(total, item) {
                return total + Number(item.cloud);
            }, 0).toFixed(0);
        }
    },
    methods: {
        getData: function () {
            axios.get("/ajax/dash/" + this.username + "/monthlytotals/" + this.year)
                .then(response => {
                    this.events = response.data;
                    this.showMessage = true;
                    this.chartOptions.series[0].data = [];

                    for (const event of this.events) {
                        this.chartOptions.series[0].data.push(Number(event.rainfall));
                    }
                })
        }
    },
    mounted() {
        this.getData();
    }
};
</script>
